/**
 * Cart Label Translations - Zepto Product Personalizer
 * Übersetzt deutsche Zepto-Labels im Warenkorb basierend auf der aktuellen Sprache
 * 
 * EINBINDUNG: 
 * Diese Datei als 'cart-translations.js' in assets/ speichern
 * Dann in layout/theme.liquid vor </body> einfügen:
 * <script src="{{ 'cart-translations.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  // ============================================================
  // ÜBERSETZUNGEN - HIER ANPASSEN
  // Format: 'Deutscher Text': 'Polnischer Text'
  // ============================================================
  
  const translations = {
    pl: {
      // =====================================================
      // LABELS (dt Elemente) - MIT Doppelpunkt
      // =====================================================
      
      // ----- Maße & Dimensionen -----
      'Stufentiefe in cm:': 'Głębokość stopnia w cm:',
      'Stufenbreite in cm:': 'Szerokość stopnia w cm:',
      'Stufentiefe:': 'Głębokość stopnia:',
      'Stufenbreite:': 'Szerokość stopnia:',
      'Tiefe:': 'Głębokość:',
      'Breite:': 'Szerokość:',
      'Höhe:': 'Wysokość:',
      'Länge:': 'Długość:',
      
      // ----- Stellstufen / Setzstufen -----
      'Stellstufe WS 130:': 'Podstopnica WS 130:',
      'Stellstufe EI 130:': 'Podstopnica EI 130:',
      'Stellstufe:': 'Podstopnica:',
      'Setzstufe:': 'Podstopnica:',
      
      // ----- LED Beleuchtung -----
      'LED Stufenbeleuchtung:': 'Oświetlenie LED stopnia:',
      'LED Beleuchtung U:': 'Oświetlenie LED U:',
      'LED Beleuchtung L:': 'Oświetlenie LED L:',
      'LED Beleuchtung:': 'Oświetlenie LED:',
      'Profile für LED Beleuchtung:': 'Profile do oświetlenia LED:',
      
      // ----- Vorschau -----
      'Vorschau:': 'Podgląd:',
      
      // ----- Sonstiges -----
      'Ausführung:': 'Wykonanie:',
      'Menge:': 'Ilość:',
      'Anzahl:': 'Liczba:',
      
      // =====================================================
      // WERTE (dd Elemente) - OHNE Doppelpunkt
      // =====================================================
      
      // ----- LED Profile -----
      'U40 LED Profil': 'Profil LED U40',
      'L-LED Profil': 'Profil L-LED',
      
      // ----- Ja/Nein -----
      'Ja': 'Tak',
      'Nein': 'Nie',
      
      // ----- Farben -----
      'altweiß': 'biel antyczna',
      'hellweiß': 'biel jasna',
      'weiß': 'biały',
      'schwarz': 'czarny',
      'grau': 'szary',
      
      // ----- Link-Texte -----
      'Klick um zu vergrößern': 'Kliknij, aby powiększyć',
      
      // ----- Einheiten -----
      'Stück': 'szt.',
      
      // =====================================================
      // FÜGE HIER WEITERE ÜBERSETZUNGEN HINZU
      // Format: 'Deutscher Text': 'Polnischer Text',
      // Bei Labels (Feldnamen): MIT Doppelpunkt am Ende
      // Bei Werten: OHNE Doppelpunkt
      // =====================================================
    }
  };

  // ============================================================
  // SCRIPT LOGIK
  // ============================================================

  function detectLanguage() {
    const path = window.location.pathname;
    if (path.startsWith('/pl/') || path.startsWith('/pl')) {
      return 'pl';
    }
    const htmlLang = document.documentElement.lang?.substring(0, 2).toLowerCase();
    if (htmlLang === 'pl') {
      return 'pl';
    }
    return 'de';
  }

  function translateText(text, lang) {
    if (lang === 'de' || !translations[lang]) {
      return text;
    }

    const langTranslations = translations[lang];
    let translatedText = text;

    // Nur exakte Übereinstimmung — substring-replace würde "Ja" in "Jasna" ersetzen
    if (langTranslations[text]) {
      return langTranslations[text];
    }
    return text;
  }

  function translateElement(el, lang) {
    // Nur Text-Knoten bearbeiten, keine Kind-Elemente überschreiben
    const walker = document.createTreeWalker(
      el,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.trim()) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(textNode => {
      const originalText = textNode.textContent;
      const translatedText = translateText(originalText, lang);
      if (originalText !== translatedText) {
        textNode.textContent = translatedText;
      }
    });
  }

  function translateCartLabels() {
    const lang = detectLanguage();
    
    if (lang === 'de') {
      return;
    }

    // Haupt-Cart Bereiche finden und komplett durchsuchen
    const cartContainers = [
      'main-cart-items',
      'cart-items', 
      'CartDrawer',
      'cart-drawer',
      'mini-cart',
      'cart'
    ];

    cartContainers.forEach(id => {
      const container = document.getElementById(id);
      if (container) {
        translateElement(container, lang);
      }
    });

    // Fallback: Alle bekannten Cart-Selektoren
    const selectors = [
      // Dawn Theme
      '.cart-item',
      '.cart-item__details',
      '.cart-item__name',
      '.cart-items td',
      '.cart-items th',
      'cart-items',
      // Properties
      'dl.product-option',
      '.product-option',
      '.cart-item dl',
      '.cart-item dt',
      '.cart-item dd',
      // Line items  
      '.line-item',
      '.line-item__property',
      // Cart drawer
      '.cart-drawer__item',
      '.drawer__item',
      // Generisch - alle p und span im Cart
      '.cart p',
      '.cart span',
      '[class*="cart"] p',
      '[class*="cart"] span',
      // Table cells
      'table[class*="cart"] td',
      'table[class*="cart"] p'
    ];

    selectors.forEach(selector => {
      try {
        document.querySelectorAll(selector).forEach(el => {
          translateElement(el, lang);
        });
      } catch (e) {
        // Ungültiger Selektor ignorieren
      }
    });

    // Spezifisch: Alle <a> Tags mit deutschen Texten
    document.querySelectorAll('a').forEach(link => {
      const text = link.textContent.trim();
      if (text.includes('Klick') || text.includes('vergrößern') || text.includes('Vorschau')) {
        const translated = translateText(text, lang);
        if (text !== translated) {
          link.textContent = translated;
        }
      }
    });
  }

  function init() {
    // Initial mit kleiner Verzögerung (DOM muss komplett sein)
    setTimeout(translateCartLabels, 100);
    // Nochmal nach 500ms falls AJAX content
    setTimeout(translateCartLabels, 500);

    // MutationObserver für dynamisch geladene Inhalte
    const observer = new MutationObserver((mutations) => {
      let shouldTranslate = false;
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              shouldTranslate = true;
            }
          });
        }
      });
      if (shouldTranslate) {
        setTimeout(translateCartLabels, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Event Listener für Cart Updates
    document.addEventListener('cart:updated', () => setTimeout(translateCartLabels, 100));
    document.addEventListener('cart:refresh', () => setTimeout(translateCartLabels, 100));
    document.addEventListener('shopify:section:load', () => setTimeout(translateCartLabels, 100));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Debug-Funktion global verfügbar
  window.CartTranslations = {
    translate: translateCartLabels,
    detectLanguage: detectLanguage,
    debug: function() {
      console.log('Sprache:', detectLanguage());
      console.log('Übersetzungen verfügbar:', Object.keys(translations.pl).length);
      // Finde alle deutschen Texte
      const found = [];
      document.querySelectorAll('*').forEach(el => {
        if (el.children.length === 0 && el.textContent) {
          const text = el.textContent.trim();
          if (text.includes('Stufen') || text.includes('LED') || text.includes('Klick')) {
            found.push({ tag: el.tagName, class: el.className, text: text.substring(0, 50) });
          }
        }
      });
      console.table(found);
    }
  };

})();